import React from 'react'
import ProjectPanel from "./components/ProjectPanel";
import ProfilePanel from "./components/ProfilePanel";
import AvailabilityPanel from "./components/AvailabilityPanel";
import ContractsPanel from "./components/ContractsPanel";
import Page from "../Page";
import WrippleEffectPanel from '../talent-dashboard/components/WrippleEffectPanel';
import JobsPreferencesPanel from "./components/JobsPreferencesPanel";
import ClientPanel from './components/ClientPanel';
import TeamsPanel from './components/TeamsPanel';
import { useAuth } from '../../providers/AuthProvider';
import { Link, useSearchParams } from "react-router-dom";
import ResetAvailabilityModal from "./components/ResetAvailabilityModal";
import ReadyToSubmitProfileModal from "../talent-application/ReadyToSubmitProfileModal";
import MessagesPanel from './components/MessagesPanel';
import PreferencesPanel from './components/PreferencesPanel';

export default class TalentDashboard extends Page {

    static path = '/dashboard';

    constructor(props, context) {
        super(props, context);
        let hasCompletedProfile = context?.auth?.hasCompletedProfile()

        this.state = {
            ...this.state,
            hasTodoItems: context?.auth?.mustSignAgreement() || !hasCompletedProfile,
            hasCompletedProfile,
            isLoading: true
        }
    }

    async componentDidMount() {
        await super.componentDidMount();

        let stats = await this.context?.auth?.getTalentUserStats();

        if (stats) {
            return this.promisedState({ isLoading: false, stats })
        }
        return this.promisedState({ isLoading: false });
    }
    async onResetAvailability() {

        if (this.state.isLoading) return false;

        await this.promisedState({ showResetModal: !this.state.showResetModal });
    }

    async resetAvailability() {

        if (this.state.isLoading) return false;

        await this.promisedState({ isLoading: true })

        let updatedAuth = await TB.auth().talentUpdate({
            talent_availability_confirmed_at: TB.moment().format('YYYY-MM-DD HH:mm:ss')
        }).catch(console.warn);
        await TB.wait(250);

        await this.promisedState({ isLoading: false })
        if (updatedAuth) {

            await TB.toast('Availability confirmed!', { type: 'success' })
        } else {
            TB.showServerErrorToast();
        }

    }

    render() {
        let {
            isLoading,
            stats
        } = this.state;

        console.log(stats, 'STATS!!!')

        const isSupplier = this.context.auth?.isTalentSupplierResource();
        const isClientInvitedAndNotOnMarketplace = this.context.auth?.isClientInvitedResource({ is_on_talent_marketplace: false });

        if (isClientInvitedAndNotOnMarketplace) {
            return (
                <div className="talent-portal-dashboard px-3 py-4 sm:px-5 sm:py-7 md:py-10">
                    <ProfilePanel
                        isLoading={isLoading}
                        colClass="md:w-6/12 xl:basis-[unset] xl:!w-4/12"
                    />

                    {/* <div className="w-full mb-6 order-2 sm:px-3 md:order-3 xl:order-4">
                        <WrippleEffectPanel />
                    </div> */}

                    <ProjectPanel
                        isLoading={isLoading}
                        opportunities={stats?.opportunities}
                        totalUpdates={stats?.total_new_invited_talent_opps}
                        lastViewed={stats?.last_viewed_talent_opps}
                        colClass="order-3 md:order-2 md:w-6/12 xl:w-4/12"
                    />

                    <ClientPanel
                        colClass="order-4 md:order-3 md:w-6/12 xl:w-4/12"
                        title="Network"
                    />

                </div>
            )
        }

        if (isSupplier) {
            return (
                <div className="talent-portal-dashboard px-3 py-4 sm:px-5 sm:py-7 md:py-10">
                    <ProfilePanel
                        isLoading={isLoading}
                        colClass="md:w-6/12 xl:basis-auto xl:!w-4/12" />

                    <div className="w-full mb-6 order-2 sm:px-3 md:order-3 xl:order-4">
                        <WrippleEffectPanel />
                    </div>

                    <ProjectPanel
                        isLoading={isLoading}
                        opportunities={stats?.opportunities}
                        totalUpdates={stats?.total_new_invited_talent_opps}
                        lastViewed={stats?.last_viewed_talent_opps}
                        colClass="order-3 md:order-2 md:w-6/12 xl:w-4/12"
                    />

                    <TeamsPanel
                        isLoading={isLoading}
                        teams={stats?.teams}
                        colClass="order-6 mb-6 w-full sm:px-3 md:w-6/12 xl:w-4/12 xl:order-3"
                    />
                    {/*<DashboardPanel
                        colClass="order-6 mb-6 w-full sm:px-3 md:w-6/12 xl:w-4/12 xl:order-3"
                        columnOrdering={{xl: 6, lg: 6, md: 6, sm: 6, xs: 6}}
                        columnProps={{sm: 12}}
                        panelClass="min-width-unset"
                        isLoading={isLoading}
                        inactiveMessage={'Form teams to deliver projects with people you already know and love working with.'}
                        title={'Collectives'}
                        disabled={this.context.auth?.mustSignAgreement()}
                        inactive={true}
                    />*/}
                </div>
            )
        }

        return (
            <div className="talent-portal-dashboard max-w-[1736px] px-3 py-4 sm:px-5 sm:py-7 md:py-10">

                <DashboardProfileStatus colClass="max-w-[calc(100vw_-_1.5rem)] w-full order-1 md:order-1 xl:order-1 mb-6" />

                <ProfilePanel
                    onResetAvailability={this.onResetAvailability.bind(this)}
                    isLoading={isLoading}
                    colClass="xl:w-2/12 xl:basis-[25%]"
                />

                <AvailabilityPanel
                    onResetAvailability={this.onResetAvailability.bind(this)}
                    isLoading={isLoading} colClass="max-w-[calc(100vw_-_1.5rem)] w-full mb-6 order-3 sm:px-3 md:w-7/12 md:order-2 xl:w-7/12 xl:basis-[50%] xl:max-w-[58.33333%]" />


                <div className='order-4 xl:order-3 xl:w-3/12 xlw-1/5'>
                    <JobsPreferencesPanel stats={stats} isLoading={isLoading} />

                    <MessagesPanel
                        isLoading={isLoading}
                        notifications={stats?.notifications}
                        totalUnread={stats?.total_unread_notifications}
                        // colClass="order-6 mb-6 w-full sm:px-3 md:w-6/12 xl:w-4/12"
                    />
                </div>

                <div className="max-w-[calc(100vw_-_1.5rem)] w-full order-2 sm:px-3 md:order-3 xl:order-4 mb-6">
                    <WrippleEffectPanel />
                </div>

                <ProjectPanel
                    isLoading={isLoading}
                    opportunities={stats?.opportunities}
                    totalUpdates={stats?.total_new_invited_talent_opps}
                    lastViewed={stats?.last_viewed_talent_opps}
                    colClass="max-w-[calc(100vw_-_1.5rem)] md:w-6/12 xl:w-3/12"
                />

                <ContractsPanel
                    isLoading={isLoading}
                    contracts={stats?.contracts}
                    totalUpdates={stats?.total_new_contracts}
                    lastViewed={stats?.last_viewed_talent_contracts}
                    colClass="md:w-6/12 xl:w-3/12"

                />

                <TeamsPanel
                    isLoading={isLoading}
                    teams={stats?.teams}
                    colClass="order-6 mb-6 w-full sm:px-3 md:w-6/12 xl:w-3/12"
                />

                <PreferencesPanel colClass="order-7 md:w-6/12 xl:w-3/12" />


                <ResetAvailabilityModal
                    isVisible={this.state.showResetModal}
                    onClose={() => this.setState({ showResetModal: false })}
                    onUpdate={this.resetAvailability.bind(this)}
                    isDisabled={isLoading}
                />
            </div>
        )
    }

    renderLastUpdated(lastUpdated) {
        if (!TB.isInteger(lastUpdated)) {
            return null;
        }

        return (
            <div className="header-last-updated">
                <p className={lastUpdated > 30 ? 'text-danger' : ''}>
                    <i className="fas fa-clock" />
                    &nbsp; {`${lastUpdated} day${(lastUpdated === 1) ? '' : 's'} ago`}
                </p>
            </div>
        )
    }
}


const DashboardProfileStatus = ({ colClass }) => {
    const { auth } = useAuth();
    const [searchParams, setSearchParams] = useSearchParams();

    // Resolve state
    const effectiveState = (() => {
        if (auth.isProfileApproved()) return null;
        if (auth.latest_appeal?.is_rejected) return 'appeal_rejected';
        if (auth.latest_appeal) return 'appeal_pending';
        if (auth.isPendingProfileApproved()) return 'under_review';
        if (auth.isProfileRejected()) return 'rejected';
        if (auth.isProfileReadyForApproval()) return 'ready_for_approval';
        return 'in_progress';
    })();

    if (!effectiveState) return null;

    const openSubmitModal = () => {
        const params = new URLSearchParams(searchParams);
        params.set('submitForApproval', '1');
        setSearchParams(params);
    };
    if (!auth.isApplicationApproved()) return null;


    const config = {
        ready_for_approval: {
            card: {
                className: 'border-2 border-amber-400',
                style: { background: 'linear-gradient(135deg, #FEF3C7 0%, #FDE68A 100%)' },
            },
            icon: (
                <div className="flex-shrink-0 w-11 h-11 bg-amber-500 text-white rounded-full flex items-center justify-center text-lg font-bold">
                    !
                </div>
            ),
            title: { text: 'Your profile is ready — submit it for approval', className: 'text-gray-900' },
            desc: { text: "You're 100% complete. Clients can't see you until Wripple reviews and approves your profile (1–2 business days).", className: 'text-gray-700' },
            action: (
                <button
                    type="button"
                    onClick={openSubmitModal}
                    className="flex-shrink-0 text-white text-sm font-semibold px-5 py-2.5 rounded-lg whitespace-nowrap transition-colors hover:bg-purple-700"
                    style={{ background: '#7C3AED', boxShadow: '0 2px 6px rgba(123, 92, 245, 0.3)' }}
                >
                    Submit for Approval →
                </button>
            ),
        },
        in_progress: {
            card: { className: 'border border-gray-200 bg-white', style: {} },
            icon: (
                <div className="flex-shrink-0 w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center text-gray-500 text-sm font-bold">
                    %
                </div>
            ),
            title: { text: 'Complete your profile to submit for approval', className: 'text-gray-800' },
            desc: { text: 'Finish the remaining sections so your profile can be reviewed by the Wripple team.', className: 'text-gray-500' },
            action: (
                <Link
                    to="/talent/application"
                    className="flex-shrink-0 text-sm font-semibold px-4 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50 whitespace-nowrap"
                >
                    Continue Profile
                </Link>
            ),
        },
        under_review: {
            card: {
                className: 'border border-purple-300',
                style: { background: 'linear-gradient(135deg, #EDE9FE 0%, #DDD6FE 100%)' },
            },
            icon: (
                <div className="flex-shrink-0 w-10 h-10 bg-purple-500 rounded-full flex items-center justify-center text-white text-base">
                    ⏱
                </div>
            ),
            title: { text: 'Your profile is under review', className: 'text-purple-900' },
            desc: { text: "We'll email you once Wripple has reviewed your profile. This typically takes 1–2 business days.", className: 'text-purple-800' },
            action: (
                <Link
                    to={`/talent-profiles/${auth.id}`}
                    className="flex-shrink-0 text-sm font-medium px-4 py-2 rounded-lg whitespace-nowrap"
                    style={{ background: 'rgba(109,40,217,0.12)', color: '#6D28D9', border: '1px solid rgba(109,40,217,0.25)' }}
                >
                    Preview Client View
                </Link>
            ),
        },
        rejected: {
            card: { className: 'border border-red-200 bg-red-50', style: {} },
            icon: (
                <div className="flex-shrink-0 w-10 h-10 bg-red-100 rounded-full flex items-center justify-center">
                    <i className="fas fa-times-circle text-red-500 text-lg" />
                </div>
            ),
            title: { text: 'Your profile was not approved', className: 'text-red-900' },
            desc: { text: 'Visit your profile to view feedback and submit an appeal for further review.', className: 'text-red-700' },
            action: (
                <Link
                    to="/talent/application"
                    className="flex-shrink-0 text-sm font-semibold px-4 py-2 rounded-lg border border-red-300 text-red-700 hover:bg-red-100 whitespace-nowrap"
                >
                    View Profile
                </Link>
            ),
        },
        appeal_pending: {
            card: { className: 'border border-orange-200 bg-orange-50', style: {} },
            icon: (
                <div className="flex-shrink-0 w-10 h-10 bg-orange-100 rounded-full flex items-center justify-center">
                    <i className="fas fa-history text-orange-500 text-lg" />
                </div>
            ),
            title: { text: 'Your appeal is under review', className: 'text-orange-900' },
            desc: { text: 'A talent manager will review your appeal and reach out via email.', className: 'text-orange-700' },
            action: null,
        },
        appeal_rejected: {
            card: { className: 'border border-red-200 bg-red-50', style: {} },
            icon: (
                <div className="flex-shrink-0 w-10 h-10 bg-red-100 rounded-full flex items-center justify-center">
                    <i className="fas fa-times-circle text-red-500 text-lg" />
                </div>
            ),
            title: { text: 'Your appeal was not approved', className: 'text-red-900' },
            desc: { text: 'Visit your profile to submit a new appeal for further review.', className: 'text-red-700' },
            action: (
                <Link
                    to="/talent/application"
                    className="flex-shrink-0 text-sm font-semibold px-4 py-2 rounded-lg border border-red-300 text-red-700 hover:bg-red-100 whitespace-nowrap"
                >
                    View Profile
                </Link>
            ),
        },
    }[effectiveState];

    return (
        <div className={colClass}>
            <div className="px-3">
                <div className={`flex items-center gap-4 p-4 rounded-xl ${config.card.className}`} style={config.card.style}>
                    {config.icon}
                    <div className="flex-1 min-w-0">
                        <div className={`font-bold text-sm leading-tight mb-0.5 ${config.title.className}`}>
                            {config.title.text}
                        </div>
                        <div className={`text-xs leading-snug ${config.desc.className}`}>
                            {config.desc.text}
                        </div>
                    </div>
                    {config.action}
                </div>
            </div>

            <ReadyToSubmitProfileModal onSubmitProfileApproval={() => { }} />
        </div>
    );
};